export default "__VITE_ASSET__CEqXb5To__"